import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";

const getMonitorTitle = (record, translate) =>
  `${translate("app.monitor")} ${record.id} (${record.name})`;

const Edit = ({ ...props }) => {
  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      {...props}
      undoable={false}
      title={<DynamicTitleWithTooltip getTitle={getMonitorTitle} />}
    >
      <Form />
    </RaEdit>
  );
};

export default Edit;
